export const TEXTURE_PATTERN_STRIPES_WIDE = 'texture-pattern-stripes-wide';
export const TEXTURE_PATTERN_HEXAGONS = 'texture-pattern-hexagons';
export const TEXTURE_PATTERN_STRIPES_CLOSE = 'texture-pattern-stripes-close';
export const TEXTURE_PATTERN_DOTS = 'texture-pattern-dots';
export const TEXTURE_PATTERN_WOVEN = 'texture-pattern-woven';

// This is used to map the texture index to the texture pattern id, do not sort or change the order
export const texturePatternIdsByTextureIndex = [
  TEXTURE_PATTERN_STRIPES_WIDE,
  TEXTURE_PATTERN_HEXAGONS,
  TEXTURE_PATTERN_STRIPES_CLOSE,
  TEXTURE_PATTERN_DOTS,
  TEXTURE_PATTERN_WOVEN,
] as const;
